import styled from 'styled-components'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const Slider = styled.span``
export const SwitchLabel = styled.label``

export const Track = styled.div.attrs((props) => composeTheme(props))`
  ${SwitchLabel} {
    display: inline-block;
    position: relative;
  }

  ${SwitchLabel} input {
    height: 0;
    opacity: 0;
    width: 0;
  }

  ${Slider} {
    background-color: ${(props) => props.theme.switch.backgroundColor};
    border-radius: ${(props) => props.theme.switch.borderRadius};
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.2s ease-out;
    -webkit-transition: 0.2s ease-out;
  }

  input:checked + ${Slider}, input:hover:checked + ${Slider} {
    background-color: ${(props) =>
      props.theme.switch.checkedBackgroundColor ||
      props.theme.brandColors.primaryPure};
  }

  input:disabled + ${Slider} {
    background-color: ${(props) => props.theme.switch.disabledBackgroundColor};
    cursor: not-allowed;
    border: ${(props) => props.theme.switch.disabledBorder};
  }

  input:disabled + ${Slider}:before {
    background-color: ${(props) =>
      props.theme.switch.sliderDisabledBackgroundColor};
    top: 0rem;
    left: 0rem;
  }

  input:focus + ${Slider} {
    box-shadow: ${(props) => props.theme.switch.focusShadow};
  }

  input:hover + ${Slider} {
    background-color: ${(props) => props.theme.switch.hoverBackgroundColor};
  }

  ${Slider}:before {
    border-radius: 10rem;
  }

  &.medium {
    ${SwitchLabel} {
      height: ${(props) => props.theme.switch.height};
      width: ${(props) => props.theme.switch.width};
    }

    ${Slider}:before {
      background-color: ${(props) => props.theme.switch.sliderBackgroundColor};

      content: '';
      height: ${(props) => props.theme.switch.sliderHeight};
      left: 0.2rem;
      position: absolute;
      top: 0.2rem;
      transition: 0.2s ease-out;
      width: ${(props) => props.theme.switch.sliderWidth};
      -webkit-transition: 0.2s ease-out;
      filter: ${(props) => props.theme.switch.sliderShadow};
    }

    input:checked + ${Slider}:before {
      -webkit-transform: translateX(
        ${(props) => props.theme.switch.sliderTransform}
      );
      -ms-transform: translateX(
        ${(props) => props.theme.switch.sliderTransform}
      );
      transform: translateX(${(props) => props.theme.switch.sliderTransform});
    }
  }

  &.large {
    ${SwitchLabel} {
      height: 3.2rem;
      width: 5.2rem;
    }

    ${Slider}:before {
      background-color: ${(props) => props.theme.switch.sliderBackgroundColor};
      bottom: 0.2rem;
      content: '';
      height: 2.8rem;
      left: 0.2rem;
      position: absolute;
      top: 0.2rem;
      transition: 0.2s ease-out;
      width: 2.8rem;
      -webkit-transition: 0.2s ease-out;
      filter: ${(props) => props.theme.switch.sliderShadow};
    }

    input:checked + ${Slider}:before {
      -webkit-transform: translateX(2rem);
      -ms-transform: translateX(2rem);
      transform: translateX(2rem);
    }
  }
`
Track.defaultProps = defaultTheme
